import { graphql, fetchQuery, type Environment } from 'react-relay';

import { createAtlAttributionHeader } from '../../utils';
import type { getIsRovoEnabledQuery } from './__generated__/getIsRovoEnabledQuery.graphql';

export const getIsRovoEnabled = async ({
	cloudId,
	relayEnvironment,
}: {
	cloudId: string;
	relayEnvironment?: Environment;
}): Promise<boolean> => {
	if (relayEnvironment) {
		const observable = fetchQuery<getIsRovoEnabledQuery>(
			relayEnvironment,
			graphql`
				query getIsRovoEnabledQuery($cloudId: ID!) {
					atlassianStudio_userSiteContext(cloudId: $cloudId) {
						... on AtlassianStudioUserSiteContextOutput {
							isRovoEnabled
						}
					}
				}
			`,
			{ cloudId },
			{
				networkCacheConfig: {
					metadata: {
						headers: {
							'atl-attribution': createAtlAttributionHeader(),
						},
					},
				},
			},
		);

		return new Promise<boolean>((resolve) => {
			observable.subscribe({
				next: (data) => {
					resolve(data?.atlassianStudio_userSiteContext?.isRovoEnabled ?? false);
				},
				error: () => {
					resolve(false);
				},
			});
		});
	}

	return false;
};
